// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__helHp","fullView":"styles_fullView__3z2_m"};